import { FieldValue } from "backend/datainput";
import { ICardElementWithChildren } from "backend/model/model";
import * as types from "client-api-workflow/types";
import ValueInputForm from "design/components/forms/ValueInputForm";
import { t } from "i18next";
import React from "react";
import { getDateFromMEAValue } from "utils/utils";
import * as validators from "./validator";
import validateInputForm from "./validator/validateInputForm";

const InitiativeInputForm = (props: {
  initiative: ICardElementWithChildren;
  childElements: ICardElementWithChildren[];
  comments?: types.WFComment[];
  attachments?: types.FileValue[];
  translatedName: string;
  onSubmit?: (values: FieldValue[]) => void;
  isReadOnly?: boolean;
}) => {
  const { initiative, childElements, attachments, comments } = props;

  const [milestoneValues, setMilestoneValues] = React.useState<FieldValue[]>(
    []
  );
  const milestones = React.useMemo(() => {
    return (childElements || []).filter(
      (item) => item.typename === "Milestone"
    );
  }, [childElements]);

  const getDateValue = (value?: Date) => {
    if (!value) return "";
    return `${value.getFullYear()}-${(value.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${value.getDate().toString().padStart(2, "0")}`;
  };

  return (
    <>
      <ValueInputForm
        key={initiative?.workflowInstance?.wfInstanceId}
        element={initiative!}
        childElements={childElements}
        buttons={[
          {
            tag: "submit",
            style: "submit",
            text: t("workflowinput.form.Submit").toString(),
            onClick: (values) => {
              console.log("initiative values", values);
              if (milestones.length > 0 && milestoneValues.length === 0) {
                return;
              }

              if (props.onSubmit) {
                const allValues = [...values, ...milestoneValues].map((v) => {
                  if (v.field.element) {
                    v.field.element.workflowInstance =
                      initiative.workflowInstance;
                  }
                  return v;
                });
                console.log("allValues", allValues);
                props.onSubmit(allValues);
              }
            },
          },
        ]}
        onIntermediateChange={(values) => {}}
        fields={[
          {
            title: t("workflowinput.form.ACTUAL_END_DATE").toString(),
            series: "ACTUAL_END_DATE",
            element: initiative,
            inputType: "datetime",
            initialValue: initiative.ACTUAL_END_DATE
              ? getDateValue(getDateFromMEAValue(initiative.ACTUAL_END_DATE))
              : undefined,
            isDisabled: props.isReadOnly,
            validate: (state) => {
              return validateInputForm(state, [validators.isNotEmpty]);
            },
          },
          {
            title: t("workflowinput.form.COMPLETION_PERCENTAGE").toString(),
            series: "COMPLETION_PERCENTAGE",
            element: initiative,
            inputType: "string",
            unitSeries: "COMPLETION_PERCENTAGE_unit",
            initialValue: initiative.COMPLETION_PERCENTAGE,
            isDisabled: props.isReadOnly,
            validate: (state) => {
              return validateInputForm(state, [
                validators.isNotEmpty,
                validators.isNumber,
              ]);
            },
          },
          {
            title: t("workflowinput.form.EXPENDITURE").toString(),
            series: "EXPENDITURE",
            element: initiative,
            inputType: "string",
            unitSeries: "EXPENDITURE_unit",
            isDisabled: props.isReadOnly,
            validate: (state) => {
              return validateInputForm(state, [
                validators.isNotEmpty,
                validators.isNumber,
              ]);
            },
          },
          {
            title: t("workflowinput.form.Attachments"),
            element: initiative,
            inputType: "attachments",
            initialFiles: attachments,
            isDisabled: props.isReadOnly,
          },
          {
            title: t("workflowinput.form.Actions and Recommendations"),
            element: initiative,
            inputType: "comment",
            comments: comments,
            isDisabled: props.isReadOnly,
            initialValue:
              comments && comments[0] ? comments[0].description : "",
          },
        ]}
      />
    </>
  );
};

export default InitiativeInputForm;
